import NextAuth from 'next-auth';
import LinkedIn from 'next-auth/providers/linkedin';
import Google from 'next-auth/providers/google';
import Credentials from 'next-auth/providers/credentials';
import {userResolve} from "@/lib/service/eidr-rest-api-service";
import {getAuthorization} from "@/lib/service/eidr-proxy-service";


const providers = [
    Google,
    LinkedIn,
    Credentials({
        // You can specify which fields should be submitted, by adding keys to the `credentials` object.
        // e.g. domain, username, password, 2FA token, etc.
        credentials: {
            username: {},
            password: {}
        },
        authorize: async (credentials) => {


            const {username, password} = credentials;
            //pull the user using the web credentials
            let {response} = await userResolve(username);

            if (response.ID) {
                //if we got a user, try to pull the user using their credentials
                const result = await userResolve(response.ID, response.ParentParty, password);
                response = result.response;
            }
            if (!response.ID) {
                //Didn't get a USER
                return false;
            }
            //Got a User! Store their authorization header for all future queries
            let user = {
                name : response.ContactInfo.Name,
                email : response.ContactInfo.PrimaryEmail,
                record : response,
                authorization : await getAuthorization(response.ID, response.ParentParty, password)
            }

            return user
        },
    }),
]

export const providerMap = providers
    .map((provider) => {
        if (typeof provider === "function") {
            // @ts-ignore
            const providerData = provider()
            return {id: providerData.id, name: providerData.name}
        } else {
            return {id: provider.id, name: provider.name}
        }
    })
    .filter((provider) => provider.id !== "credentials")

export const {handlers, signIn, signOut, auth} = NextAuth({
    trustHost: true,
    providers: providers,
    basePath: '/auth',
    session: {strategy: 'jwt'
    },
    cookies: {
        sessionToken: {
            options: {
                domain: process.env.AUTH_DOMAIN,
                path: "/",
                httpOnly: true,
                sameSite: "lax",
                expires: null
            }
        }
    },
    callbacks: {
        authorized({request, auth}) {
            const {pathname} = request.nextUrl;
            if (pathname === '/middleware-example') return !!auth;
            return true;
        },
        jwt({token, trigger, session, account}) {
            if (trigger === 'update') token.name = session.user.name;
            if (account?.provider === 'keycloak') {
                return {...token, accessToken: account.access_token};
            }
            return token;
        },
        async session({session, token}) {
            // @ts-ignore
            if (token?.accessToken) session.accessToken = token.accessToken;
            return session;
        },
    },
    experimental: {enableWebAuthn: true},
    pages: {
        signIn: "/auth/signin",
        signOut: "/auth/signout",
    }
});
